import React from 'react';
import { motion } from 'framer-motion';
import { useContactModal } from '../../../stores/modalStore';
import './AboutUsCTA.css';

const AboutUsCTA: React.FC = () => {
  const { open: openContactModal } = useContactModal();

  return (
    <motion.section
      className="about-cta"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.8, ease: 'easeOut' }}
    >
      <div className="about-cta-container">
        <div className="about-cta-content">
          <h2 className="about-cta-title">Ready to <span className="highlight">Transform</span> Your Clinical Trials?</h2>
          <p className="about-cta-text">
            Join hundreds of pharmaceutical companies and research institutions that trust Cinquity for their eCOA needs.
          </p>
          <button className="about-cta-button" onClick={openContactModal}>
            Get Started Today
          </button>
        </div>
      </div>
    </motion.section>
  );
};

export default AboutUsCTA;
